export type ThemePreference = "system" | "light" | "dark";

const STORAGE_KEY = "fieldbook:theme";
export const THEME_CHANGE_EVENT = "fieldbook:theme-change";

export function getThemePreference(): ThemePreference {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "light" || stored === "dark" ? stored : "system";
}

// "system" means no override — let the :root[data-theme] CSS block be
// absent so the prefers-color-scheme media query decides, same as before
// this toggle existed.
export function applyThemePreference(pref: ThemePreference) {
  if (pref === "system") {
    document.documentElement.removeAttribute("data-theme");
  } else {
    document.documentElement.setAttribute("data-theme", pref);
  }
}

export function setThemePreference(pref: ThemePreference) {
  localStorage.setItem(STORAGE_KEY, pref);
  applyThemePreference(pref);
  window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, { detail: pref }));
}
